// extracted by mini-css-extract-plugin
module.exports = {"donutWrapper":"Donut_donutWrapper__3wvTy","donutName":"Donut_donutName__2P94G"};